// removed by extract-text-webpack-plugin
module.exports = {"Widget":"Widget---1dxAI","icon-type-dismiss":"icon-type-dismiss---nfVi2","Widget__Count":"Widget__Count---1rK42"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/Customize/Preview/Widget/style.styl
// module id = g+Sm
// module chunks = 89